var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('h2',{staticClass:"text-danger"},[_vm._v("Account Locked Out")]),_c('p',{staticClass:"text-danger"},[_vm._v("This account has been locked out, please try again later.")])])
}]

export { render, staticRenderFns }